import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Mail, Lock, User } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

export default function SignupPage() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            if (!agreedToTerms) {
                setError('You must agree to the Terms & Conditions');
                setLoading(false);
                return;
            }
            await register(email, password, name, agreedToTerms);
            navigate('/');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--bg-primary)',
            padding: '24px'
        }}>
            <div style={{
                width: '100%',
                maxWidth: '440px'
            }}>
                {/* Logo */}
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <Link to="/">
                        <img
                            src="/atam-logo.svg"
                            alt="ATAM"
                            style={{ height: '40px', width: 'auto' }}
                        />
                    </Link>
                </div>

                {/* Card */}
                <div className="card" style={{ padding: '40px' }}>
                    <h1 style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        marginBottom: '8px',
                        textAlign: 'center'
                    }}>
                        Create Account
                    </h1>
                    <p style={{
                        color: 'var(--text-secondary)',
                        textAlign: 'center',
                        marginBottom: '32px'
                    }}>
                        Join ATAM Connect to discover Singapore's Indian Heritage and Arts
                    </p>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label className="form-label">Name</label>
                            <div style={{ position: 'relative' }}>
                                <User
                                    size={18}
                                    style={{
                                        position: 'absolute',
                                        left: '14px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'var(--text-muted)'
                                    }}
                                />
                                <input
                                    type="text"
                                    className="form-input"
                                    style={{ paddingLeft: '44px' }}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Your name"
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="form-label">Email</label>
                            <div style={{ position: 'relative' }}>
                                <Mail
                                    size={18}
                                    style={{
                                        position: 'absolute',
                                        left: '14px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'var(--text-muted)'
                                    }}
                                />
                                <input
                                    type="email"
                                    className="form-input"
                                    style={{ paddingLeft: '44px' }}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="you@example.com"
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="form-label">Password</label>
                            <div style={{ position: 'relative' }}>
                                <Lock
                                    size={18}
                                    style={{
                                        position: 'absolute',
                                        left: '14px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'var(--text-muted)'
                                    }}
                                />
                                <input
                                    type="password"
                                    className="form-input"
                                    style={{ paddingLeft: '44px' }}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="••••••••"
                                    required
                                    minLength={6}
                                />
                            </div>
                        </div>

                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{
                                display: 'flex',
                                alignItems: 'start',
                                gap: '12px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                color: 'var(--text-secondary)'
                            }}>
                                <input
                                    type="checkbox"
                                    checked={agreedToTerms}
                                    onChange={(e) => setAgreedToTerms(e.target.checked)}
                                    required
                                    style={{
                                        marginTop: '4px',
                                        width: '16px',
                                        height: '16px',
                                        cursor: 'pointer'
                                    }}
                                />
                                <span>
                                    I agree to the{' '}
                                    <Link
                                        to="/terms"
                                        style={{
                                            color: 'var(--primary)',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        Terms & Conditions
                                    </Link>
                                    {' '}and{' '}
                                    <Link
                                        to="/privacy"
                                        style={{
                                            color: 'var(--primary)',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        Privacy Policy
                                    </Link>
                                </span>
                            </label>
                        </div>

                        {error && (
                            <div className="form-error" style={{ marginBottom: '16px' }}>
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: '100%', marginBottom: '16px' }}
                            disabled={loading}
                        >
                            {loading ? 'Please wait...' : 'Create Account'}
                        </button>
                    </form>

                    <div style={{ textAlign: 'center', color: 'var(--text-secondary)', fontSize: '14px' }}>
                        Already have an account?{' '}
                        <Link
                            to="/login"
                            style={{ color: 'var(--primary)', fontWeight: '500', textDecoration: 'none' }}
                        >
                            Sign in
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
